// extracted by mini-css-extract-plugin
export default {"container":"QuestionToggle_container__xZVjw","items":"QuestionToggle_items__jxHez"};